import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.css']
})
export class LegalComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/ThinkBIT/work-projects/confe/hosting/src/app/legal.component.ts